<template>
  <input-custom v-bind:id="id"
                v-bind:errors="errors"
                v-bind:label="label"
                v-bind:language="language"
                v-bind:required="required">
    <div class="row">
      <div class="col">
        <input type="text"
               v-model="link"
               placeholder="https://"
               v-bind:maxlength="2000"
               class="form-control"/>
      </div>
      <div v-if="value" class="col-auto">
        <button v-on:click.prevent="removeValue" class="btn btn-outline-danger"><i class="fal fa-trash-alt"></i>
        </button>
      </div>
    </div>
    <iframe v-if="iframeSrc"
            width="300" height="225" rel="0"
            v-bind:src="iframeSrc"
            frameborder="0" allowfullscreen="true"
            class="mt-3"/>
    <template v-if="help" v-slot:help="">
      <slot></slot>
    </template>
  </input-custom>
</template>

<script>
import Vue from "vue";

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    value: {},
    errors: {
      type: Array
    },
    label: {
      type: String
    },
    language: {
      type: String
    },
    required: {
      type: Boolean
    },
  },
  computed: {
    link: {
      get: function () {
        return Vue.$videoPlugin.getLinkByToken(this.value);
      },
      set: function (newValue) {
        var token = Vue.$videoPlugin.getTokenByLink(newValue);
        this.updateValue(token);
      }
    },
    iframeSrc: function () {
      return Vue.$videoPlugin.getEmbedByToken(this.value);
    },
    help: function () {
      return !!this.$scopedSlots.default;
    },
  },
  methods: {
    removeValue: function () {
      this.updateValue(null);
    },
    updateValue: function (value) {
      this.$emit("input", value);
    }
  }
}
</script>
